import React from 'react';
import { Box, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import InfoCard from '../info-card/InfoCard';
import { storeContext } from '../provider/Provider';
import publishingIcon from '../../images/icon-publishing.svg';
import publishedIcon from '../../images/icon-published.svg';
import residualIcon from '../../images/residual.svg';
import reviewIcon from '../../images/icon-review.svg';
import topicsIcon from '../../images/icon-topics.svg';
import qaIcon from '../../images/icon-qa.svg';
import writingIcon from '../../images/icon-writing.svg';

const useStyles = makeStyles((theme) => ({
  card__flex: {
    margin: '0.6em 0.6em',
    flexGrow: 1,
    display: 'flex',
    borderRadius: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    height: 140,
    color: 'white',
    minWidth: 120,
    [theme.breakpoints.down('sm')]: {
      margin: 10,
      height: 100,
    },
    '& > span': {
      height: '100%',
    }
  },
  card__flex__orange: {
    minWidth: 120,
    margin: '0.6em 0.6em',
    flexGrow: 1,
    display: 'flex',
    borderRadius: '16px',
    alignItems: 'center',
    justifyContent: 'center',
    height: 140,
    color: 'white',
    border: '5px solid orange',
    [theme.breakpoints.down('sm')]: {
      margin: 10,
      height: 100,
    },
  },
  pipelineFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    '& a': {
      width: '15%',
    },
  },

  pipelineFlexInfo: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 15,
    '&>div': {
      width: '100%',
    },
  },
  card__content: {
    textAlign: 'center',
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: '20px',
    padding: '10px',
    height: '120px',
  },
  value: {
    fontWeight: 900,
    fontSize: 46,
    lineHeight: '45px',
    fontFamily: 'Roboto',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 700,
      fontSize: 32,
    },
  },
  cardName: {
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: 600,
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '17px',
    },
  },
  nextIcon: {
    fontSize: 40,
    width: '55px',
    display: 'flex',
    alignSelf: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 30,
      width: '40px',
    },
  },
  contentFlex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: '120px',
    [theme.breakpoints.down('sm')]: {
      width: '50px',
    },
  },
}));


const ContentPipeline = () => {
  const { state } = React.useContext(storeContext);

  const classes = useStyles();
  return (
    <>
      {state.content.contentCountByType["Topics for Review"] === 0 &&
      state.content.contentCountByType.Writing === 0 &&
      state.content.contentCountByType.QA === 0 &&
      state.content.contentCountByType["Content for Review"] === 0 &&
      state.content.contentCountByType["Approved with Comments"] === 0 &&
      state.content.contentCountByType.Revisions === 0 &&
      state.content.contentCountByType["Revised Content for Review"] === 0 &&
      state.content.contentCountByType.Publishing === 0 &&
      state.content.contentCountByType.Published === 0 &&
      state.content.contentCountByType["Residual Content"] === 0 ? (
        <div className={classes.pipelineFlexInfo}>
          <InfoCard
            name=""
            value=""
            tooltip="Content Information"
            explanation="Content information unavailable as we are currently in the process of uploading your content plans to the Platform. Please check back soon."
          />
        </div>
      ) : (
        <div className={classes.pipelineFlex}>
          {state.content.contentCountByType["Topics for Review"] === 0 ? (
            <Button
              component={Link}
              to="/content/full-view/topics_for_review"
              className={classes.card__flex}
              style={{ background: '#072D5B' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={topicsIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Topics for Review</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Topics for Review"]}
                  </span>
                </div>
              </div>
            </Button>
          ) : (
            <Button
              component={Link}
              to="/content/full-view/topics_for_review"
              className={classes.card__flex__orange}
              style={{ background: '#072D5B' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={topicsIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Topics for Review</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Topics for Review"]}
                  </span>
                </div>
              </div>
            </Button>
          )}

          <Button
            component={Link}
            to="/content/full-view/writing"
            className={classes.card__flex}
            style={{ background: '#1C5DAC' }}
          >
            <div className={classes.card__content}>
              <div className={classes.contentFlex}>
                <Box component='img' src={writingIcon} className={classes.nextIcon} />
              </div>
              <div className={classes.contentFlex}>
                <span className={classes.cardName}>Writing</span>
                <span className={classes.value}>
                  {state.content.contentCountByType.Writing}
                </span>
              </div>
            </div>
          </Button>
          {state.content.contentCountByType["Writing (External Content)"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/writing_external_content"
              className={classes.card__flex}
              style={{ background: '#3486C2' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={writingIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Writing - External Content</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType['Writing (External Content)']}
                  </span>
                </div>
              </div>
            </Button>
          )}
          {state.content.contentCountByType["Needs Edits (External Content)"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/needs_edits_external_content"
              className={classes.card__flex__orange}
              style={{ background: '#3486C2' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={writingIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Needs Edits (External Content)</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType['Needs Edits (External Content)']}
                  </span>
                </div>
              </div>
            </Button>
          )}
          {state.content.contentCountByType.Hold !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/hold"
              className={classes.card__flex}
              style={{ background: '#C1C5CB' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={publishingIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Hold</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType.Hold}
                  </span>
                </div>
              </div>
            </Button>
          )}
          <Button
            component={Link}
            to="/content/full-view/qa"
            className={classes.card__flex}
            style={{ background: '#65ADD3' }}
          >
            <div className={classes.card__content}>
              <div className={classes.contentFlex}>
                <Box component='img' src={qaIcon} className={classes.nextIcon} />
              </div>
              <div className={classes.contentFlex}>
                <span className={classes.cardName}>QA</span>
                <span className={classes.value}>
                  {state.content.contentCountByType.QA}
                </span>
              </div>
            </div>
          </Button>
          <Button
            component={Link}
            to="/content/full-view/content_for_review"
            className={classes.card__flex__orange}
            style={{ background: '#9DECDF' }}
          >
            <div className={classes.card__content}>
              <div className={classes.contentFlex}>
                <Box component='img' src={reviewIcon} className={classes.nextIcon} />
              </div>
              <div className={classes.contentFlex}>
                <span className={classes.cardName}>Content for Review</span>
                <span className={classes.value}>
                  {state.content.contentCountByType["Content for Review"]}
                </span>
              </div>
            </div>
          </Button>
          {state.content.contentCountByType.Revisions !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/revisions"
              className={classes.card__flex}
              style={{ background: '#C1EAA4' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={publishingIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Revisions</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType.Revisions}
                  </span>
                  
                </div>
              </div>
            </Button>
          )}
          {state.content.contentCountByType["Revised Content for Review"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/revised_content_for_review"
              className={classes.card__flex}
              style={{ background: '#E4E868' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={reviewIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Revised Content for Review</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Revised Content for Review"]}
                  </span>
                  
                </div>
              </div>
            </Button>
          )}
          {state.content.contentCountByType["Approved with Comments"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/approved"
              className={classes.card__flex}
              style={{ background: '#AED94E' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={reviewIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Approved with Comments</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Approved with Comments"]}
                  </span>
                  
                </div>
              </div>
            </Button>
          )}
          <Button
            component={Link}
            to="/content/full-view/publishing"
            className={classes.card__flex}
            style={{ background: '#00B14C' }}
          >
            <div className={classes.card__content}>
              <div className={classes.contentFlex}>
                <Box component='img' src={publishingIcon} className={classes.nextIcon} />
              </div>
              <div className={classes.contentFlex}>
                <span className={classes.cardName}>Publishing</span>
                <span className={classes.value}>
                  {state.content.contentCountByType.Publishing}
                </span>

              </div>
            </div>
          </Button>
          {state.content.contentCountByType["Published on Development Site"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/published_on_dev"
              className={classes.card__flex}
              style={{ background: '#0A8C4C' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={publishingIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Published on Development Site</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Published on Development Site"]}
                  </span>
                </div>
              </div>
            </Button>
          )}
          <Button
            component={Link}
            to="/content/full-view/published"
            className={classes.card__flex}
            style={{ background: '#0A8C4C' }}
          >
            <div className={classes.card__content}>
              <div className={classes.contentFlex}>
                <Box component='img' src={publishedIcon} className={classes.nextIcon} />
              </div>
              <div className={classes.contentFlex}>
                <span className={classes.cardName}>Published</span>
                <span className={classes.value}>
                  {state.content.contentCountByType.Published}
                </span>
                
              </div>
            </div>
          </Button>
          {state.content.contentCountByType["Residual Content"] !== 0 && (
            <Button
              component={Link}
              to="/content/full-view/residual_content"
              className={classes.card__flex}
              style={{ background: '#666666' }}
            >
              <div className={classes.card__content}>
                <div className={classes.contentFlex}>
                  <Box component='img' src={residualIcon} className={classes.nextIcon} />
                </div>
                <div className={classes.contentFlex}>
                  <span className={classes.cardName}>Residual Content</span>
                  <span className={classes.value}>
                    {state.content.contentCountByType["Residual Content"]}
                  </span>
                </div>
              </div>
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default ContentPipeline;
